import { c as _c } from "react/compiler-runtime";
import type { AutoshipCustomerApiResponse } from '@libs/common-types';
import { useAutoshipSubscriptionsQuery } from '../queries';
export type UseCustomerAutoshipSubscriptionsResult = {
  autoshipData: AutoshipCustomerApiResponse | undefined;
  isReady: boolean;
  isLoading: boolean;
  isFetching: boolean;
  isError: boolean;
  error: Error | null;
};
const ONE_MINUTE = 60 * 1000;
export const useCustomerAutoshipSubscriptions = () => {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      staleTime: ONE_MINUTE
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: autoshipData,
    isLoading,
    isFetching,
    isError,
    error
  } = useAutoshipSubscriptionsQuery(t0);
  const isReady = !isLoading && !isError;
  let t1;
  if ($[1] !== autoshipData || $[2] !== error || $[3] !== isError || $[4] !== isFetching || $[5] !== isLoading || $[6] !== isReady) {
    t1 = {
      autoshipData,
      isReady,
      isLoading,
      isFetching,
      isError,
      error
    };
    $[1] = autoshipData;
    $[2] = error;
    $[3] = isError;
    $[4] = isFetching;
    $[5] = isLoading;
    $[6] = isReady;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
};